// extracted by mini-css-extract-plugin
export default {"root":"QT1iQaEi4lgx1lLsYJceQw=="};